<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Parceiros</h3>
        </div>
        <!-- Page Header - Filters -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button
              type="button"
              class="btn btn-primary btn-sm mt-3"
              @click="OpenModalFilter()"
            >
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span v-if="countFilter > 0" class="badge badge-light">{{
                countFilter
              }}</span>
            </button>
            <b-button
              v-if="countFilter > 0"
              variant="primary"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Limpar filtros"
              @click="ResetFilter()"
            >
              <i class="fas fa-eraser"></i>
            </b-button>
          </div>
        </div>
      </div>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">Parceiros</h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <b-input-group class="d-flex justify-content-end my-auto ml-2">
                  <h6 class="m-0">
                    {{ pagination.TotalItems | number }}
                    {{ pagination.TotalItems > 1 ? " itens" : "item" }}
                  </h6>
                  <div class="dropdown m-0">
                    <button
                      class="btn btn-outline-secondary dropdown-toggle-ellipsis"
                      type="button"
                      v-b-tooltip.hover.right
                      title="Mais opções"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i class="fas fa-ellipsis-v"></i>
                    </button>
                    <div
                      class="dropdown-menu"
                      id="dropTableOptions"
                      aria-labelledby="dropdownMenuButton"
                    >
                      <a
                        class="dropdown-item"
                        href="#"
                        :class="loadingReport ? 'disabled' : ''"
                        v-on:click.stop="GetReport($event)"
                      >
                        <template v-if="loadingReport">
                          <loader
                            :small="true"
                            :isLoading="loadingReport"
                          ></loader>
                        </template>
                        <template v-else>
                          <i class="fas fa-check mr-2"></i>
                          Gerar relatório
                        </template>
                      </a>
                      <a
                        class="dropdown-item"
                        href="#"
                        v-on:click.stop="OpenModalReportProfit($event)"
                      >
                        <template>
                          <i class="fas fa-check mr-2"></i>
                          Gerar relatório de faturamento
                        </template>
                      </a>
                      <a
                        class="dropdown-item"
                        href="#"
                        v-on:click.stop="OpenModalReportPerfomance($event)"
                      >
                        <template>
                          <i class="fas fa-check mr-2"></i>
                          Gerar relatório de desempenho
                        </template>
                      </a>
                    </div>
                  </div>
                </b-input-group>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList"></loader>
              <table class="table mb-0" v-if="!loadingList">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0 text-left">ID</th>
                    <th scope="col" class="border-0 text-left">
                      {{ labelName }}
                    </th>
                    <th scope="col" class="border-0">Origem</th>
                    <th scope="col" class="border-0">Contato</th>
                    <th scope="col" class="border-0">Data do cadastro</th>
                    <th scope="col" class="border-0"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(partner, index) in partners" :key="index">
                    <td></td>
                    <td class="text-left">{{ partner.Id }}</td>
                    <td class="text-left td-with-subs">
                      <div>{{ partner.Name | substring(50) }}</div>
                      <span>{{ partner.Identity | identity }}</span>
                    </td>
                    <td>{{ partner.SourceDescription }}</td>
                    <td>{{ partner.Phone | phone }}</td>
                    <td class="td-with-subs">
                      <div>{{ partner.CreatedDate | date }}</div>
                      <span>{{ partner.CreatedDate | date("HH:mm:ss") }}</span>
                    </td>
                    <td>
                      <div
                        class="dropdown"
                        :class="window.width < 1880 ? 'dropleft' : ''"
                      >
                        <button
                          class="btn btn-outline-secondary dropdown-toggle"
                          type="button"
                          id="dropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          Opções
                        </button>
                        <div
                          class="dropdown-menu"
                          aria-labelledby="dropdownMenuButton"
                        >
                          <a
                            v-if="$isAuthorize('Partner', 'Get')"
                            class="dropdown-item"
                            href="#"
                            v-on:click="OpenMPartner($event, index, true)"
                          >
                            <i class="fas fa-eye mr-2"></i> Visualizar
                          </a>
                          <a
                            v-if="
                              !partner.IsExcluded &&
                              $isAuthorize('Partner', 'Update')
                            "
                            class="dropdown-item"
                            href="#"
                            v-on:click="OpenMPartner($event, index)"
                          >
                            <i class="fas fa-highlighter mr-2"></i> Editar
                          </a>
                          <a
                            v-if="
                              !partner.IsExcluded &&
                              $isAuthorize('Partner', 'UpdateExcluded')
                            "
                            class="dropdown-item"
                            href="#"
                            v-on:click="
                              ProcessUpdateExcludedPartner(index, true)
                            "
                          >
                            <i class="fas fa-minus-square mr-2"></i> Desativar
                          </a>
                          <a
                            v-if="$isAuthorize('Prospect', 'List')"
                            class="dropdown-item"
                            href="#"
                            v-on:click="OpenProspect($event, partner.Id)"
                          >
                            <i class="fas fa-id-badge mr-2"></i> Visualizar
                            negociações em andamento
                          </a>
                          <a
                            v-if="$isAuthorize('Merchant', 'List')"
                            class="dropdown-item"
                            href="#"
                            v-on:click="OpenMerchant($event, partner.Id)"
                          >
                            <i class="fas fa-user-check mr-2"></i> Visualizar
                            clientes
                          </a>
                          <a
                            v-if="
                              $isAuthorize('CheckingAccountPartner', 'List')
                            "
                            class="dropdown-item"
                            href="#"
                            v-on:click="
                              OpenPartnerCommissions($event, partner.Id)
                            "
                          >
                            <i class="fas fa-hand-holding-usd mr-2"></i>
                            Visualizar comissões
                          </a>
                          <a 
                            v-if="
                              $isAuthorize('ParceiroAtendimentoIdParceiro', 'List')
                            " 
                            class="dropdown-item"
                            href="#" 
                            v-on:click="
                            AbrirParceiroAtendimentoIdParceiro($event, partner.Id)
                              "
                          >
                            <i class="fas fa-sticky-note mr-2"></i> 
                            Atendimento ao parceiro
                          </a>
                          <a
                            v-if="
                              partner.IsExcluded &&
                              $isAuthorize('Partner', 'UpdateExcluded')
                            "
                            class="dropdown-item"
                            href="#"
                            v-on:click="
                              ProcessUpdateExcludedPartner(index, false)
                            "
                          >
                            <i class="fas fa-check-square mr-2"></i> Ativar
                          </a>
                          <div
                            v-if="
                              !partner.IsExcluded &&
                              partner.PartnerStatus.Code == '1' &&
                              $isAuthorize('Partner', 'UpdateStatus')
                            "
                          >
                            <a
                              class="dropdown-item"
                              href="#"
                              v-on:click="
                                ProcessUpdatePartnerStatus(index, true, 2)
                              "
                            >
                              <i class="fas fa-thumbs-up mr-2"></i> Aprovar
                            </a>
                            <a
                              v-if="$isAuthorize('Partner', 'UpdateStatus')"
                              class="dropdown-item"
                              href="#"
                              v-on:click="
                                ProcessUpdatePartnerStatus(index, false, 3)
                              "
                            >
                              <i class="fas fa-thumbs-down mr-2"></i> Recusar
                            </a>
                          </div>
                          <a
                            v-if="
                              !partner.IsExcluded &&
                              partner.PartnerStatus.Code == '2' &&
                              $isAuthorize('Partner', 'UpdateStatus')
                            "
                            class="dropdown-item"
                            href="#"
                            v-on:click="
                              ProcessUpdatePartnerStatus(index, false, 3)
                            "
                          >
                            <i class="fas fa-thumbs-down mr-2"></i> Recusar
                          </a>
                          <a
                            v-if="
                              !partner.IsExcluded &&
                              partner.PartnerStatus.Code == '3' &&
                              $isAuthorize('Partner', 'UpdateStatus')
                            "
                            class="dropdown-item"
                            href="#"
                            v-on:click="
                              ProcessUpdatePartnerStatus(index, true, 2)
                            "
                          >
                            <i class="fas fa-thumbs-up mr-2"></i> Aprovar
                          </a>
                          <!-- <a
                            v-if="
                              !partner.IsExcluded &&
                              $isAuthorize('Ticket', 'Add')
                            "
                            class="dropdown-item"
                            href="#"
                            v-on:click="
                              OpenTicketRegister($event, {
                                IdPartner: partner.Id,
                              })
                            "
                          >
                            <i class="fas fa-ticket-alt mr-2"></i> Abrir chamado
                          </a> -->
                          <a
                            v-if="$isAuthorize('Partner', 'UpdateEmail')"
                            class="dropdown-item"
                            href="#"
                            v-on:click="OpenChangeEmail($event, partner.Id)"
                          >
                            <i class="fas fa-envelope mr-2"></i> Alterar e-mail
                          </a>
                          <a
                            v-if="
                              !partner.IsExcluded &&
                              partner.CodeSolicitationV2 == '' &&
                              partner.MerchantType.Code == '2' &&
                              partner.PartnerType.Code == '2' &&
                              $isAuthorize('Partner', 'GetContract')
                            "
                            class="dropdown-item"
                            href="#"
                            v-on:click="OpenPartnerContract($event, partner.Id)"
                          >
                            <i class="fas fa-file-signature mr-2"></i>
                            Contrato
                          </a>
                          <a
                            v-if="
                              !partner.IsRemoved &&
                              $isAuthorize('Training', 'List')
                            "
                            class="dropdown-item"
                            href="#"
                            v-on:click="
                              OpenPartnerTrainings($event, partner.Id)
                            "
                          >
                            <i class="fas fa-headset mr-2"></i>
                            Reuniões
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      partners == undefined ||
                      partners == null ||
                      partners.length == 0
                    "
                  >
                    <td colspan="5">Sem registros</td>
                  </tr>
                </tbody>
              </table>

              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                    aria-controls="my-table"
                  ></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      size="lg"
      id="mFormPartner"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <template v-slot:modal-header>
        <h5 class="col-10 no-gutters mb-0">
          {{ modalTitle }}
          <template v-if="idPartner">
            {{ partner.Name }}
            <template v-if="isSeeing">[{{ idPartner }}]</template>
          </template>
        </h5>
        <button class="close" @click="HideModal()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </template>
      <loader :is-loading="loadingModal"></loader>

      <nav v-if="!loadingModal" class="nav-steps" aria-label="breadcrumb">
        <ol
          style="background-color: #fff; padding: 0.75rem 0rem"
          class="breadcrumb"
        >
          <li class="breadcrumb-item">
            <a
              class="black-text"
              href="#"
              v-on:click="GoToStep($event, 0)"
              :class="[pCurrentStep == 0 ? 'active' : '']"
              >Parceiro</a
            >
            <i class="fas fa-angle-right mx-2" aria-hidden="true"></i>
          </li>
          <li class="breadcrumb-item">
            <a
              class="black-text"
              href="#"
              v-on:click="GoToStep($event, 1)"
              :class="[pCurrentStep == 1 ? 'active' : '']"
              >Endereço</a
            >
            <i class="fas fa-angle-right mx-2" aria-hidden="true"></i>
          </li>
          <li class="breadcrumb-item" v-if="isSeeing">
            <a
              class="black-text"
              href="#"
              v-on:click="GoToStep($event, 2)"
              :class="[pCurrentStep == 2 ? 'active' : '']"
              >Documentos</a
            >
            <i
              class="fas fa-angle-right mx-2"
              aria-hidden="true"
              v-if="partnerStatusHistories.length > 0 || !isSeeing"
            ></i>
          </li>
          <li class="breadcrumb-item" v-if="partnerStatusHistories.length > 0">
            <a
              class="black-text"
              href="#"
              v-on:click="GoToStep($event, 3)"
              :class="[pCurrentStep == 3 ? 'active' : '']"
              >Status</a
            >
          </li>
          <li class="breadcrumb-item" v-if="HasPartnerTickets">
            <i class="fas fa-angle-right mx-2" aria-hidden="true"></i>
            <a
              class="black-text"
              href="#"
              v-on:click="GoToStep($event, 4)"
              :class="[pCurrentStep == 4 ? 'active' : '']"
              >Chamados</a
            >
          </li>
          <li class="breadcrumb-item" v-if="!isSeeing">
            <a
              class="black-text"
              href="#"
              v-on:click="GoToStep($event, 5)"
              :class="[pCurrentStep == 5 ? 'active' : '']"
              >Confirmação</a
            >
          </li>
        </ol>
      </nav>

      <!--  Partner - Step: 0 -->
      <div v-if="pCurrentStep === 0 && !loadingModal">
        <ValidationObserver tag="form" ref="PartnerStep">
          <d-form-row>
            <d-col md="6">
              <div class="form-group">
                <label>Tipo de parceiro</label>
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors, invalid }"
                >
                  <d-select
                    :class="validatedPartnerStep | showValidateError(invalid)"
                    v-model="partner.PartnerType.Code"
                    :disabled="isSeeing"
                    @change="onChangePartnerType"
                  >
                    <option :value="null">Selecione</option>
                    <option
                      v-for="type in partnerTypes"
                      v-bind:value="type.Code"
                      v-bind:key="type.Code"
                    >
                      {{ type.Name }}
                    </option>
                  </d-select>
                  <div
                    class="invalid-feedback d-block"
                    v-if="validatedPartnerStep"
                  >
                    {{ errors[0] }}
                  </div>
                </ValidationProvider>
              </div>
            </d-col>
            <d-col md="6">
              <div class="form-group">
                <label v-if="!isSeeing">Perfil do parceiro</label>
                <label v-else>Tipo de conta</label>
                <d-select
                  v-model="partner.MerchantType.Code"
                  :disabled="isSeeing || isDisableMerchantType"
                >
                  <option :value="'1'">Pessoa Física</option>
                  <option :value="'2'">Pessoa Jurídica</option>
                </d-select>
              </div>
            </d-col>
          </d-form-row>
          <d-form-row>
            <d-col md="4">
              <div class="form-group">
                <d-checkbox
                  v-model="partner.IsTest"
                  :disabled="isSeeing || pOpened != null"
                  >Utilizado para teste</d-checkbox
                >
              </div>
            </d-col>
            <d-col md="4">
              <div class="form-group">
                <d-checkbox v-model="partner.IsEnabled" :disabled="true"
                  >Habilitado para comissão</d-checkbox
                >
              </div>
            </d-col>
            <d-col md="4">
              <div class="form-group">
                <d-checkbox v-model="partner.IsBankDataEnabled" :disabled="true"
                  >Dados bancários ativos</d-checkbox
                >
              </div>
            </d-col>
          </d-form-row>
          <h4>Dados do parceiro</h4>
          <hr />
          <d-form-row v-if="isSeeing">
            <d-col md="6" class="form-group">
              <label>Data do cadastro</label>
              <d-form-input
                type="text"
                v-bind:value="partner.CreatedDate | date('DD/MM/YYYY - HH:mm')"
                readonly
              />
            </d-col>
            <d-col md="6" class="form-group">
              <label>Parceiro</label>
              <d-form-input type="text" v-bind:value="partner.Name" readonly />
            </d-col>
          </d-form-row>
          <d-form-row>
            <d-col md="4" class="form-group">
              <label v-if="partner.MerchantType.Code == 1">Nome</label>
              <label v-else>Razão social</label>
              <ValidationProvider
                rules="required|min:3"
                v-slot="{ errors, invalid }"
              >
                <d-form-input
                  v-if="partner.MerchantType.Code == '1'"
                  type="text"
                  :class="validatedPartnerStep | showValidateError(invalid)"
                  v-model="partner.Name"
                  @input="Update('ResponsibleName', $event)"
                  :disabled="isSeeing"
                />
                <d-form-input
                  v-else
                  type="text"
                  :class="validatedPartnerStep | showValidateError(invalid)"
                  v-model="partner.Name"
                  :disabled="isSeeing"
                />
                <div
                  class="invalid-feedback d-block"
                  v-if="validatedPartnerStep"
                >
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
            <d-col
              md="4"
              v-if="partner.MerchantType.Code == 1"
              class="form-group"
            >
              <label>CPF</label>
              <ValidationProvider
                rules="required|min:11|identity"
                v-slot="{ errors, invalid }"
              >
                <the-mask
                  class="form-control"
                  :class="validatedPartnerStep | showValidateError(invalid)"
                  type="text"
                  :mask="['###.###.###-##']"
                  v-model="partner.Identity"
                  @input="Update('ResponsibleIdentity', $event)"
                  :disabled="isSeeing"
                />
                <div
                  class="invalid-feedback d-block"
                  v-if="validatedPartnerStep"
                >
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
            <d-col md="4" v-else class="form-group">
              <label>CNPJ</label>
              <ValidationProvider
                rules="required|min:14"
                v-slot="{ errors, invalid }"
              >
                <the-mask
                  class="form-control"
                  :class="validatedPartnerStep | showValidateError(invalid)"
                  type="text"
                  :mask="['##.###.###/####-##']"
                  v-model="partner.Identity"
                  :disabled="isSeeing"
                />
                <div
                  class="invalid-feedback d-block"
                  v-if="validatedPartnerStep"
                >
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
            <d-col md="4" class="form-group">
              <label>{{
                partner.MerchantType.Code == 1
                  ? "Nome comercial"
                  : "Nome fantasia"
              }}</label>
              <d-form-input
                type="text"
                v-model="partner.CommercialName"
                :disabled="isSeeing"
              />
            </d-col>
          </d-form-row>
          <d-form-row>
            <d-col
              :md="partner.MerchantType.Code == 1 ? '4' : '6'"
              class="form-group"
            >
              <label>Nome do contato</label>
              <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                <d-form-input
                  type="text"
                  :class="validatedPartnerStep | showValidateError(invalid)"
                  v-model="partner.ContactName"
                  :disabled="isSeeing"
                />
                <div
                  class="invalid-feedback d-block"
                  v-if="validatedPartnerStep"
                >
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
            <d-col
              v-if="partner.MerchantType.Code == 1"
              md="4"
              class="form-group"
            >
              <label>E-mail</label>
              <ValidationProvider
                rules="required|email"
                v-slot="{ errors, invalid }"
              >
                <div class="input-group">
                  <d-form-input
                    type="text"
                    :class="validatedPartnerStep | showValidateError(invalid)"
                    v-model="partner.Email"
                    :disabled="isSeeing || pOpened != null"
                  />
                  <button
                    type="button"
                    class="btn btn-primary ml-2"
                    v-b-tooltip.hover.bottom
                    title="Reenviar e-mail"
                    @click="ConfirmResendEmail($event)"
                    :disabled="
                      isSeeing ||
                      loadingResendEmail ||
                      invalid ||
                      partner.Email == undefined ||
                      partner.Email == null ||
                      partner.Email.length == 0
                    "
                  >
                    <template v-if="!loadingResendEmail">
                      <i class="fas fa-paper-plane"></i>
                    </template>
                    <template v-else>
                      <loader
                        :small="true"
                        :labelEnabled="false"
                        :isLoading="loadingResendEmail"
                      ></loader>
                    </template>
                  </button>
                </div>
                <div
                  class="invalid-feedback d-block"
                  v-if="validatedPartnerStep"
                >
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
            <d-col
              :md="partner.MerchantType.Code == 1 ? '4' : '6'"
              class="form-group"
            >
              <label>Telefone</label>
              <ValidationProvider
                rules="required|min:10"
                v-slot="{ errors, invalid }"
              >
                <d-input-group seamless>
                  <d-input-group-text slot="prepend">
                    <i class="fas fa-phone-alt"></i>
                  </d-input-group-text>
                  <the-mask
                    v-if="partner.MerchantType.Code == 1"
                    class="form-control"
                    :class="validatedPartnerStep | showValidateError(invalid)"
                    type="tel"
                    :mask="['(##) #####-####', '(##) ####-####']"
                    v-model="partner.Phone"
                    @input="Update('ResponsiblePhone', $event)"
                    :disabled="isSeeing"
                  />
                  <the-mask
                    v-else
                    class="form-control"
                    :class="validatedPartnerStep | showValidateError(invalid)"
                    type="tel"
                    :mask="['(##) #####-####', '(##) ####-####']"
                    v-model="partner.Phone"
                    :disabled="isSeeing"
                  />
                </d-input-group>
                <div
                  class="invalid-feedback d-block"
                  v-if="validatedPartnerStep"
                >
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>
          <div v-if="partner.MerchantType.Code != 1">
            <h4>Dados do responsável</h4>
            <hr />
            <d-form-row>
              <d-col md="6" class="form-group">
                <label>Nome</label>
                <ValidationProvider
                  rules="required:true|min:10|name"
                  v-slot="{ errors, invalid }"
                >
                  <d-form-input
                    :class="validatedPartnerStep | showValidateError(invalid)"
                    type="text"
                    v-model="partner.ResponsibleName"
                    :disabled="isSeeing"
                  />
                  <div
                    class="invalid-feedback d-block"
                    v-if="validatedPartnerStep"
                  >
                    {{ errors[0] }}
                  </div>
                </ValidationProvider>
              </d-col>
              <d-col md="6" class="form-group float-right">
                <label>CPF</label>
                <ValidationProvider
                  rules="required|min:11|identity"
                  v-slot="{ errors, invalid }"
                >
                  <the-mask
                    class="form-control"
                    :class="validatedPartnerStep | showValidateError(invalid)"
                    type="text"
                    :mask="['###.###.###-##']"
                    v-model="partner.ResponsibleIdentity"
                    :disabled="isSeeing"
                  />
                  <div
                    class="invalid-feedback d-block"
                    v-if="validatedPartnerStep"
                  >
                    {{ errors[0] }}
                  </div>
                </ValidationProvider>
              </d-col>
            </d-form-row>
            <d-form-row>
              <d-col md="6" class="form-group">
                <label>E-mail</label>
                <ValidationProvider
                  rules="required|email"
                  v-slot="{ errors, invalid }"
                >
                  <div class="input-group">
                    <d-form-input
                      :class="validatedPartnerStep | showValidateError(invalid)"
                      type="text"
                      v-model="partner.Email"
                      :disabled="isSeeing || pOpened != null"
                    />
                    <button
                      type="button"
                      class="btn btn-primary ml-2"
                      v-b-tooltip.hover.bottom
                      title="Reenviar e-mail"
                      @click="ConfirmResendEmail($event)"
                      :disabled="
                        isSeeing ||
                        loadingResendEmail ||
                        invalid ||
                        partner.Email == undefined ||
                        partner.Email == null ||
                        partner.Email.length == 0
                      "
                    >
                      <template v-if="!loadingResendEmail">
                        <i class="fas fa-paper-plane"></i>
                      </template>
                      <template v-else>
                        <loader
                          :small="true"
                          :labelEnabled="false"
                          :isLoading="loadingResendEmail"
                        ></loader>
                      </template>
                    </button>
                  </div>
                  <div
                    class="invalid-feedback d-block"
                    v-if="validatedPartnerStep"
                  >
                    {{ errors[0] }}
                  </div>
                </ValidationProvider>
              </d-col>
              <d-col md="6" class="form-group">
                <label for="parPhone">Telefone</label>
                <ValidationProvider
                  rules="required|min:10"
                  v-slot="{ errors, invalid }"
                >
                  <d-input-group seamless>
                    <d-input-group-text slot="prepend">
                      <i class="fas fa-phone-alt"></i>
                    </d-input-group-text>
                    <the-mask
                      id="parPhone"
                      class="form-control"
                      type="tel"
                      :class="validatedPartnerStep | showValidateError(invalid)"
                      :mask="['(##) #####-####', '(##) ####-####']"
                      v-model="partner.ResponsiblePhone"
                      :disabled="isSeeing"
                    />
                  </d-input-group>
                  <div
                    class="invalid-feedback d-block"
                    v-if="validatedPartnerStep"
                  >
                    {{ errors[0] }}
                  </div>
                </ValidationProvider>
              </d-col>
            </d-form-row>
          </div>
        </ValidationObserver>
      </div>

      <!--  Address - Step: 1 -->
      <div v-show="pCurrentStep === 1">
        <ValidationObserver tag="form" ref="AddressStep">
          <d-form-row>
            <d-col md="4" class="form-group">
              <label>CEP</label>
              <ValidationProvider
                rules="required|min:8"
                v-slot="{ errors, invalid }"
              >
                <the-mask
                  v-model="partner.Address.ZipCode"
                  :class="validatedAddressStep | showValidateError(invalid)"
                  :disabled="isSeeing"
                  @change.native="SearchByZipCode()"
                  class="form-control"
                  type="tel"
                  :mask="['#####-###']"
                />
                <div
                  class="invalid-feedback d-block"
                  v-if="validatedAddressStep"
                >
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
            <d-col md="8" class="form-group">
              <label>Rua</label>
              <ValidationProvider
                rules="required|min:3"
                v-slot="{ errors, invalid }"
              >
                <d-form-input
                  type="text"
                  :class="validatedAddressStep | showValidateError(invalid)"
                  v-model="partner.Address.Street"
                  :disabled="isSeeing"
                />
                <div
                  class="invalid-feedback d-block"
                  v-if="validatedAddressStep"
                >
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>
          <d-form-row>
            <d-col md="4" class="form-group">
              <label>Número</label>
              <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                <the-mask
                  class="form-control"
                  type="tel"
                  :class="validatedAddressStep | showValidateError(invalid)"
                  :mask="['##########']"
                  v-model="partner.Address.Number"
                  :disabled="isSeeing"
                />
                <div
                  class="invalid-feedback d-block"
                  v-if="validatedAddressStep"
                >
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
            <d-col md="8" class="form-group">
              <label>Bairro</label>
              <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                <d-form-input
                  type="text"
                  v-model="partner.Address.District"
                  :class="validatedAddressStep | showValidateError(invalid)"
                  :disabled="isSeeing"
                />
                <div
                  class="invalid-feedback d-block"
                  v-if="validatedAddressStep"
                >
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>

          <d-form-row>
            <!-- Country -->
            <d-col md="4" class="form-group">
              <label for="parInputCountry">País</label>
              <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                <d-select
                  v-model="partner.Address.Country.Name"
                  :value="null"
                  :class="validatedAddressStep | showValidateError(invalid)"
                  id="parInputCountry"
                  v-bind:disabled="isSeeing"
                >
                  <option :value="null" selected>Selecione</option>
                  <option
                    v-for="country in countries"
                    v-bind:value="country.Name"
                    v-bind:key="country.Id"
                  >
                    {{ country.Name }}
                  </option>
                </d-select>
                <div
                  class="invalid-feedback d-block"
                  v-if="validatedAddressStep"
                >
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>

            <!-- State -->
            <d-col md="4" class="form-group">
              <label for="parInputState">Estado</label>
              <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                <d-select
                  v-model="partner.Address.State.Initials"
                  :value="null"
                  :class="validatedAddressStep | showValidateError(invalid)"
                  id="parInputState"
                  v-bind:disabled="isSeeing"
                >
                  <option :value="null" selected>Selecione</option>
                  <option
                    v-for="state in states"
                    v-bind:key="state.Initials"
                    v-bind:value="state.Initials"
                  >
                    {{ state.Name }}
                  </option>
                </d-select>
                <div
                  class="invalid-feedback d-block"
                  v-if="validatedAddressStep"
                >
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>

            <!-- City -->
            <d-col md="4" class="form-group">
              <label for="parInputCity">Cidade</label>
              <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                <d-select
                  v-model="partner.Address.City.Name"
                  :value="null"
                  :class="validatedAddressStep | showValidateError(invalid)"
                  id="parInputCity"
                  v-bind:disabled="isSeeing"
                >
                  <option
                    :value="null"
                    v-if="partner.Address.State.Initials == null"
                    selected
                  >
                    Selecione
                  </option>
                  <option :value="null" v-else selected>Selecione</option>
                  <option
                    v-for="city in cities"
                    v-bind:key="city.Name"
                    v-bind:value="city.Name"
                  >
                    {{ city.Name }}
                  </option>
                </d-select>
                <div
                  class="invalid-feedback d-block"
                  v-if="validatedAddressStep"
                >
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>
        </ValidationObserver>
      </div>

      <!-- Partner Docs - Step: 2 -->
      <div v-if="pCurrentStep === 2 && isSeeing">
        <h4>Documentos</h4>
        <div class="card-body p-0 pb-3 text-center">
          <table class="table mb-0">
            <thead class="bg-s2p-gray-light">
              <tr>
                <th scope="col" class="border-0">Tipo de documento</th>
                <th scope="col" class="border-0">Data de criação</th>
                <th scope="col" class="border-0">Ativo?</th>
                <th scope="col" class="border-0"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(partnerDoc, index) in partnerDocs" :key="index">
                <td>{{ partnerDoc.PartnerDocType.Name }}</td>
                <td>{{ partnerDoc.CreatedDate | date }}</td>
                <td>
                  <i :class="[GetIsExcludedClass(partnerDoc.IsExcluded)]"></i>
                </td>
                <td>
                  <div class="dropdown">
                    <button
                      class="btn btn-outline-secondary dropdown-toggle"
                      type="button"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      Opções
                    </button>
                    <div
                      class="dropdown-menu"
                      aria-labelledby="dropdownMenuButton"
                    >
                      <a
                        class="dropdown-item"
                        href="#"
                        :class="loadingDownload ? 'disabled' : ''"
                        v-on:click.stop="
                          GetAllPartnerDoc(partnerDoc.Id, true, true)
                        "
                      >
                        <template v-if="loadingDownload">
                          <loader
                            :small="true"
                            :isLoading="loadingDownload"
                          ></loader>
                        </template>
                        <template v-else>
                          <i class="fas fa-long-arrow-alt-down mr-2"></i>
                          Download
                        </template>
                      </a>
                      <a
                        v-if="!partnerDoc.IsExcluded"
                        class="dropdown-item"
                        href="#"
                        v-on:click="
                          ConfirmDeletePartnerDoc(
                            $event,
                            partnerDoc.PartnerDocType.Name,
                            partnerDoc.Id
                          )
                        "
                      >
                        <i class="fas fa-trash-alt mr-2"></i> Remover
                      </a>
                    </div>
                  </div>
                </td>
              </tr>
              <tr
                v-if="
                  partnerDocs == undefined ||
                  partnerDocs == null ||
                  partnerDocs.length == 0
                "
              >
                <td colspan="5">Sem registros</td>
              </tr>
            </tbody>
          </table>

          <div class="col-12 border-top">
            <div class="pagination-nav">
              <b-pagination
                class="float-right"
                v-model="paginationPartnerDoc.PageNumber"
                :total-rows="paginationPartnerDoc.TotalItems"
                :per-page="paginationPartnerDoc.RowsPerPage"
                aria-controls="my-table"
              ></b-pagination>
              <div class="float-left">
                <d-select size="sm" v-model="paginationPartnerDoc.RowsPerPage">
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="30">30</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                  <option value="200">200</option>
                  <option value="500">500</option>
                </d-select>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- StatusHistories 3 -->
      <div v-if="pCurrentStep === 3 && isSeeing">
        <h4>Status</h4>
        <h6>*Somente as 5 últimas atualizações serão listadas*</h6>
        <table
          class="table mb-0"
          :key="tableKey"
          v-if="partnerStatusHistories.length > 0"
        >
          <thead class="bg-s2p-gray-light">
            <tr>
              <th class="text-center">Usuário interno</th>
              <th class="text-center">Status</th>
              <th class="text-center">Data</th>
              <th></th>
            </tr>
          </thead>

          <tbody>
            <tr
              v-for="(partnerStatusHistory, index) in partnerStatusHistories"
              :key="index"
            >
              <td class="text-center">
                {{ partnerStatusHistory.UserInternal.Name }}
              </td>
              <td class="text-center">
                {{ partnerStatusHistory.PartnerStatus.Name }}
              </td>
              <td class="text-center">
                {{ partnerStatusHistory.ChangedDate | date }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Tickets / Chamados - 4 -->
      <!-- <div v-if="pCurrentStep === 4 && HasPartnerTickets">
        <table class="table mb-0" :key="ticketsTableKey">
          <thead class="bg-s2p-gray-light">
            <tr>
              <th scope="col" class="border-0 text-left">Número</th>
              <th scope="col" class="border-0 text-center">Origem</th>
              <th scope="col" class="border-0 text-center">Status</th>
              <th scope="col" class="border-0 text-center">Data do cadastro</th>
              <th scope="col" class="border-0 text-right"></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(ticket, index) in partnerTickets"
              :key="'ticket-' + index + '-' + ticket.Id"
            >
              <td class="text-left">{{ ticket.Id }}</td>
              <td class="text-center">
                {{ GetGenericName("TicketSourceList", ticket.Source.Code) }}
              </td>
              <td class="text-center">
                {{ GetGenericName("TicketStatusList", ticket.Status.Code) }}
              </td>
              <td class="text-center">{{ ticket.CreatedDate | date }}</td>
              <td class="text-right">
                <div class="dropdown">
                  <button
                    class="btn btn-outline-secondary dropdown-toggle"
                    type="button"
                    id="dropdownMenuButton"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    Opções
                  </button>
                  <div
                    class="dropdown-menu"
                    aria-labelledby="dropdownMenuButton"
                  >
                    <a
                      class="dropdown-item"
                      href="#"
                      v-on:click="
                        OpenTicketRegister($event, { IdTicket: ticket.Id })
                      "
                    >
                      <i class="fas fa-eye mr-2"></i> Visualizar
                    </a>
                    <a
                      class="dropdown-item"
                      href="#"
                      v-if="ticket.Status.Code != '5'"
                      v-on:click="
                        OpenTicketRegister($event, {
                          IdTicket: ticket.Id,
                          Mode: 'finish',
                        })
                      "
                    >
                      <i class="fas fa-check mr-2"></i> Finalizar
                    </a>
                    <a
                      class="dropdown-item"
                      href="#"
                      v-if="ticket.Status.Code == '5'"
                      v-on:click="
                        OpenTicketRegister($event, {
                          IdTicket: ticket.Id,
                          Mode: 'reopen',
                        })
                      "
                    >
                      <i class="fas fa-lock-open mr-2"></i> Reabrir
                    </a>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div> -->

      <!--  Confirmation - Step: 5 -->
      <div v-if="pCurrentStep === 5">
        <h4>Confirmação</h4>
        <div>
          <d-form-row>
            <d-col class="col-12">
              <p class="font-weight-bold mb-4">Informações do parceiro</p>
              <div v-if="partner.MerchantType.Code == 1">
                <p class="mb-2">Nome: {{ partner.Name }}</p>
                <p class="mb-2">CPF: {{ Identity }}</p>
              </div>
              <div v-else>
                <p class="mb-2">Razão Social: {{ partner.Name }}</p>
                <p class="mb-2">CNPJ: {{ Identity }}</p>
                <p class="mb-2">
                  Responsável: {{ partner.ResponsibleName }} -
                  {{ ResponsibleIdentity }}
                </p>
              </div>
              <p class="account-type mb-2">
                Perfil do parceiro: {{ MerchantTypeName }}
              </p>
              <p class="mb-5">
                Endereço: {{ partner.Address.Street }},
                {{ partner.Address.Number }} - {{ partner.Address.District }},
                {{ partner.Address.City.Name }} -
                {{ partner.Address.State.Initials }} -
                {{ partner.Address.Country.Name }}
              </p>
            </d-col>
          </d-form-row>
        </div>
      </div>

      <template slot="modal-footer">
        <b-button-group>
          <b-button
            size="sm"
            class="btn btn-secondary"
            @click="BackStep()"
            :disabled="pCurrentStep === 0 || loadingModal"
          >
            <i class="fas fa-arrow-left"></i>
          </b-button>

          <b-button
            @click="ProcessNextStep()"
            class="btn btn-secondary"
            size="sm"
            v-if="pCurrentStep !== 5"
            :disabled="
              ((pCurrentStep === 3 && !HasPartnerTickets) ||
                pCurrentStep === 4 ||
                (pCurrentStep === 2 && partnerStatusHistories.length === 0)) &&
              isSeeing
            "
          >
            <i class="fas fa-arrow-right"></i>
          </b-button>
          <b-button
            type="button"
            class="btn btn-success"
            :disabled="loadingModal || isSeeing"
            v-on:click="CreateOrUpdate()"
            v-if="pCurrentStep === 5"
          >
            <template v-if="!loadingModal">{{
              pOpened != null ? " Salvar alterações" : " Cadastrar parceiro"
            }}</template>
            <template v-else>
              <loader :small="true" :isLoading="loadingModal"></loader>
            </template>
          </b-button>
        </b-button-group>
      </template>
    </b-modal>

    <b-modal
      id="mFormPartnerContract"
      title="Gerar contrato"
      size="lg"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <div>
        <h5>Instruções</h5>
        <hr />
        <label
          >- Informe os dados dos responsáveis apenas quando for diferente do
          informado na receita federal</label
        >
        <label class="mb-4"
          >- IMPORTANTE: se estes campos forem informados, o nome do responsável
          que está cadastrado será desconsiderado</label
        >
        <h5>Dados do Responsável</h5>
        <hr />
        <div>
          <ValidationObserver tag="form" ref="PartnerContractForm">
            <d-form-row>
              <d-col md="4" class="form-group">
                <label>Nome</label>
                <ValidationProvider
                  rules="required:true|min:10|name"
                  v-slot="{ errors, invalid }"
                >
                  <d-form-input
                    :class="
                      validatedPartnerContract | showValidateError(invalid)
                    "
                    type="text"
                    v-model="activePartnerResponsible.ResponsibleName"
                  />
                  <div
                    class="invalid-feedback d-block"
                    v-if="validatedPartnerContract"
                  >
                    {{ errors[0] }}
                  </div>
                </ValidationProvider>
              </d-col>
              <d-col md="4" class="form-group">
                <label>CPF</label>
                <ValidationProvider
                  rules="required|min:11"
                  v-slot="{ errors, invalid }"
                >
                  <the-mask
                    class="form-control"
                    :class="
                      validatedPartnerContract | showValidateError(invalid)
                    "
                    type="text"
                    :mask="['###.###.###-##']"
                    v-model="activePartnerResponsible.ResponsibleIdentity"
                  />
                  <div
                    class="invalid-feedback d-block"
                    v-if="validatedPartnerContract"
                  >
                    {{ errors[0] }}
                  </div>
                </ValidationProvider>
              </d-col>
              <d-col md="4" class="form-group">
                <label>E-mail</label>
                <ValidationProvider
                  rules="required|email"
                  v-slot="{ errors, invalid }"
                >
                  <d-form-input
                    type="text"
                    :class="
                      validatedPartnerContract | showValidateError(invalid)
                    "
                    v-model="activePartnerResponsible.ResponsibleEmail"
                  />
                  <div
                    class="invalid-feedback d-block"
                    v-if="validatedPartnerContract"
                  >
                    {{ errors[0] }}
                  </div>
                </ValidationProvider>
              </d-col>
            </d-form-row>
            <d-form-row>
              <b-col>
                <b-button
                  class="float-right"
                  variant="success"
                  size="sm"
                  @click="AddPartnerResponsible($event)"
                  >Incluir Responsável</b-button
                >
              </b-col>
            </d-form-row>
          </ValidationObserver>
        </div>
        <div
          v-if="
            infoPartnerContract.Responsibles != null &&
            infoPartnerContract.Responsibles != undefined &&
            infoPartnerContract.Responsibles.length > 0
          "
        >
          <br />
          <table class="table mb-0">
            <thead class="bg-s2p-gray-light">
              <tr>
                <th>Nome</th>
                <th>CPF</th>
                <th>E-mail</th>
                <th class="actions"></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(responsible, index) in infoPartnerContract.Responsibles"
                :key="index"
              >
                <td>{{ responsible.ResponsibleName }}</td>
                <td>{{ responsible.ResponsibleIdentity | identity }}</td>
                <td>{{ responsible.ResponsibleEmail }}</td>
                <td>
                  <div class="text-right">
                    <b-button
                      size="sm"
                      variant="outline-secondary"
                      @click="RemovePartnerResponsible(index)"
                    >
                      <i class="fas fa-trash-alt" />
                    </b-button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <template slot="modal-footer" slot-scope="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="cancel()">Fechar</b-button>
        <b-button
          size="sm"
          variant="success"
          @click="GetPartnerContract()"
          :disabled="loadingContract"
        >
          <template v-if="!loadingContract">
            Gerar
            <i class="fas fa-arrow-right"></i>
          </template>
          <template v-else>
            <loader :small="true" :isLoading="loadingContract"></loader>
          </template>
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="mFilter"
      title="Filtros"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <d-form-row>
        <d-col md="6" class="form-group">
          <input
            :placeholder="labelId"
            type="text"
            class="form-control"
            v-model="filter.Id"
            v-on:keyup.enter="Filter()"
          />
        </d-col>
        <d-col md="6" class="form-group">
          <the-mask
            class="form-control"
            type="tel"
            :mask="['###.###.###-##', '##.###.###/####-##']"
            v-model="filter.Identity"
            v-bind:placeholder="labelIdentity"
            v-on:keyup.enter.native="Filter()"
          />
        </d-col>
      </d-form-row>

      <d-form-row>
        <d-col md="12" class="form-group">
          <input
            :placeholder="labelName"
            type="text"
            class="form-control"
            v-model="filter.Name"
            v-on:keyup.enter="Filter()"
          />
        </d-col>
      </d-form-row>

      <d-form-row>
        <d-col md="6" class="form-group">
          <d-select v-model="filter.CodeMerchantType" :value="null">
            <option :value="null" selected>Tipo de conta</option>
            <option :value="1">Pessoa física</option>
            <option :value="2">Pessoa jurídica</option>
          </d-select>
        </d-col>
        <d-col md="6" class="form-group">
          <d-select v-model="filter.IsExcluded" :value="null">
            <option :value="false">Ativos</option>
            <option :value="true">Inativos</option>
          </d-select>
        </d-col>
      </d-form-row>
      <d-form-row>
        <d-col md="6" class="form-group">
          <d-select v-model="filter.CodePartnerType" :value="null">
            <option :value="null" selected>Tipo de parceiro</option>
            <option
              v-for="type in partnerTypes"
              v-bind:key="type.Code"
              v-bind:value="type.Code"
            >
              {{ type.Name }}
            </option>
          </d-select>
        </d-col>
        <d-col md="6" class="form-group">
          <d-select v-model="filter.IsTest" :value="null">
            <option :value="false">Parceiros</option>
            <option :value="true">Parceiros de teste</option>
          </d-select>
        </d-col>
      </d-form-row>
      <d-form-row>
        <d-col md="6" class="form-group">
          <d-select
            v-model="filter.AddressFilter.StateFilter.Initials"
            :value="null"
          >
            <option :value="null" selected>Estado</option>
            <option
              v-for="state in statesFilter"
              v-bind:key="state.Initials"
              v-bind:value="state.Initials"
            >
              {{ state.Name }}
            </option>
          </d-select>
        </d-col>
        <d-col md="6" class="form-group">
          <d-select v-model="filter.CodePartnerStatus" :value="null">
            <option :value="null" selected>Status do parceiro</option>
            <option
              v-for="type in partnerStatus"
              v-bind:key="type.Code"
              v-bind:value="type.Code"
            >
              {{ type.Name }}
            </option>
          </d-select>
        </d-col>
      </d-form-row>
      <d-form-row>
        <d-col md="6" class="form-group">
          <d-select v-model="filter.IsAcceptedContract" :value="null">
            <option :value="2">Contrato assinado?</option>
            <option :value="1">Assinado</option>
            <option :value="0">Não assinado</option>
          </d-select>
        </d-col>
        <d-col md="6" class="form-group">
          <d-select v-model="filter.IsModifiedIdentity" :value="null">
            <option :value="2">Documento alterado?</option>
            <option :value="1">Alterado</option>
            <option :value="0">Não alterado</option>
          </d-select>
        </d-col>
      </d-form-row>
      <template slot="modal-footer">
        <b-button
          variant="primary"
          class="btn btn-primary"
          v-b-tooltip.hover.bottom
          title="Pesquisar"
          @click="Filter()"
        >
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          variant="primary"
          class="input-group-text"
          v-b-tooltip.hover.bottom
          title="Limpar filtros"
          @click="ResetFilter()"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="mReportProfit"
      title="Relatório de Faturamento"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <d-form-row>
        <d-col md="12" class="form-group">
          <label>Data de faturamento</label>
          <date-field
            v-model="reportDate"
            format="MMMM yyyy"
            minimumView="month"
          />
        </d-col>
      </d-form-row>
      <template slot="modal-footer" slot-scope="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="cancel()">Fechar</b-button>
        <b-button
          size="sm"
          variant="success"
          @click="GetReportProfit()"
          :disabled="loadingReportProfit"
        >
          <template v-if="!loadingReportProfit">
            Gerar
            <i class="fas fa-arrow-right"></i>
          </template>
          <template v-else>
            <loader :small="true" :isLoading="loadingReportProfit"></loader>
          </template>
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="mReportPerformance"
      title="Relatório de Desempenho"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <d-form-row>
        <d-col md="12" class="form-group">
          <label>Período</label>
          <date-field
            v-model="reportDate"
            format="MMMM yyyy"
            minimumView="month"
          />
        </d-col>
      </d-form-row>
      <template slot="modal-footer" slot-scope="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="cancel()">Fechar</b-button>
        <b-button
          size="sm"
          variant="success"
          @click="GetReportPerformance()"
          :disabled="loadingReportPerformance"
        >
          <template v-if="!loadingReportPerformance">
            Gerar
            <i class="fas fa-arrow-right"></i>
          </template>
          <template v-else>
            <loader
              :small="true"
              :isLoading="loadingReportPerformance"
            ></loader>
          </template>
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="mChangeEmail"
      title="Alterar e-mail"
      size="md"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <div>
        <ValidationObserver tag="form" ref="ChangeEmailForm">
          <d-form-row>
            <d-col md="12" class="form-group">
              <label>E-mail</label>
              <ValidationProvider
                rules="required|email"
                v-slot="{ errors, invalid }"
              >
                <div class="input-group">
                  <d-form-input
                    :class="validatedChangeEmail | showValidateError(invalid)"
                    type="email"
                    v-model="infoPartnerUpdateEmail.Email"
                  />
                </div>
                <div
                  class="invalid-feedback d-block"
                  v-if="validatedChangeEmail"
                >
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>
        </ValidationObserver>
      </div>
      <template slot="modal-footer" slot-scope="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="cancel()">Fechar</b-button>
        <b-button
          size="sm"
          variant="success"
          @click="ValidateUpdateEmail()"
          :disabled="loadingChangeEmail"
        >
          <template v-if="!loadingChangeEmail">
            Alterar
            <i class="fas fa-arrow-right"></i>
          </template>
          <template v-else>
            <loader :small="true" :isLoading="loadingChangeEmail"></loader>
          </template>
        </b-button>
      </template>
    </b-modal>

    <a
      v-if="$isAuthorize('Partner', 'Add')"
      href="#"
      class="btn-float success"
      v-b-tooltip.hover
      title="Novo parceiro"
      v-on:click="OpenMPartner($event)"
    >
      <i class="fa fa-plus"></i>
    </a>

    <ticket-register :OnClose="OnCloseTicketModal" />
  </div>
</template>

<script>
import dateField from "../common/date-field";
import ticketRegister from "../modals/ticketRegister.vue";
import { hasValue } from "../../utils/functions.js";
import { mapGetters } from "vuex";

export default {
  name: "partners",
  components: {
    dateField,
    ticketRegister,
  },
  data: function () {
    return {
      reportDate: this.$options.filters.date(
        this.$options.filters.addMonth(new Date(), -1),
        "YYYY-MM-DD"
      ),
      countFilter: 0,
      idPartner: 0,
      isSearchZipCode: false,
      labelId: "Id do Parceiro",
      labelIdentity: "CPF/CNPJ",
      labelName: "Nome do Parceiro",
      listPending: false,
      listPendingAcceptedContract: false,
      listModifiedIdentity: false,
      loadingList: false,
      loadingModal: false,
      loadingReport: false,
      loadingReportProfit: false,
      loadingReportPerformance: false,
      loadingResendEmail: false,
      loadingContract: false,
      loadingListPartnerDoc: false,
      loadingDownload: false,
      loadingChangeEmail: false,
      mSteps: [
        "partner",
        "address",
        "docs",
        "status",
        "tickets",
        "confirmation",
      ],
      merchantTypes: [],
      modalTitle: "Novo parceiro",
      pCurrentStep: 0,
      partnerTickets: [],
      partners: [],
      validatedAddressStep: false,
      validatedPartnerStep: false,
      validatedChangeEmail: false,
      validatedPartnerContract: false,
      pagination: {
        RowsPerPage: 10,
        PageNumber: 1,
        TotalItems: 0,
      },
      filter: {
        Name: null,
        Identity: null,
        CodeMerchantType: null,
        CodePartnerType: null,
        CodePartnerStatus: null,
        IsExcluded: false,
        IsTest: false,
        IsAcceptedContract: 2,
        IsModifiedIdentity: 2,
        AddressFilter: {
          StateFilter: {
            Initials: null,
          },
        },
      },
      partner: {
        Id: undefined,
        Name: null,
        Identity: null,
        Email: null,
        Phone: null,
        ContactName: null,
        CommercialName: null,
        IsTest: false,
        MerchantType: {
          Code: null,
        },
        PartnerType: {
          Code: null,
        },
        Address: {
          Street: null,
          District: null,
          Number: null,
          ZipCode: null,
          Complement: null,
          City: {
            Name: null,
          },
          State: {
            Initials: null,
          },
          Country: {
            Name: null,
          },
        },
        UserInternal: null,
      },
      activePartnerResponsible: {
        ResponsibleName: null,
        ResponsibleIdentity: null,
        ResponsibleEmail: null,
      },
      infoPartnerContract: {
        IdPartner: 0,
        Responsibles: [],
      },
      infoPartnerUpdateEmail: {
        Id: 0,
        Email: null,
        ResponsibleIdentity: null,
      },
      cities: [],
      countries: [],
      isSeeing: false,
      isDisableMerchantType: false,
      pOpened: null,
      partnerStatus: [],
      partnerStatusHistories: [],
      partnerTypes: [],
      partnerDocs: [],
      paginationPartnerDoc: {
        RowsPerPage: 10,
        PageNumber: 1,
        TotalItems: 0,
      },
      states: [],
      statesFilter: [],
      tableKey: 0,
      ticketsTableKey: 0,
      window: {
        width: 0,
        height: 0,
      },
    };
  },
  computed: {
    Country() {
      return this.partner.Address.Country.Name;
    },
    State() {
      return this.partner.Address.State.Initials;
    },
    Identity() {
      if (hasValue(this.partner.Identity))
        return this.$options.filters.identity(this.partner.Identity);
      else return "";
    },
    ResponsibleIdentity() {
      if (hasValue(this.partner.ResponsibleIdentity))
        return this.$options.filters.identity(this.partner.ResponsibleIdentity);
      else return "";
    },
    MerchantTypeName() {
      const currentMTcode = this.partner.MerchantType.Code;

      if (currentMTcode == "1") return "Pessoa física";
      else if (currentMTcode == "2") return "Pessoa jurídica";
      else return "";
    },
    HasPartnerTickets() {
      return this.isSeeing && this.partnerTickets.length > 0;
    },
    // ...mapGetters(["TicketSourceList", "TicketStatusList"]),
  },
  watch: {
    "pagination.PageNumber": function () {
      this.ListPartner();
    },
    "pagination.RowsPerPage": function () {
      this.ListPartner();
    },
    "paginationPartnerDoc.PageNumber": function () {
      this.ListPartnerDocs();
    },
    "paginationPartnerDoc.RowsPerPage": function () {
      this.ListPartnerDocs();
    },
    State(selected, old) {
      // Update City list when the State (of Country) is changed.
      if (selected != null) {
        this.$store
          .dispatch("ListCity", { stateInitials: selected })
          .then((response) => {
            this.cities = response;
          });
        if (selected != old && old != undefined && !this.isSearchZipCode) {
          this.partner.Address.City.Name = null;
        }
      } else {
        this.cities = [];
        this.partner.Address.City.Name = null;
      }
      if (this.isSearchZipCode) this.isSearchZipCode = false;
    },
    Country(selected, old) {
      // Update State list when the Country is changed.
      if (selected != null) {
        this.ListState(selected);
        if (selected != old && old != undefined && !this.isSearchZipCode) {
          this.partner.Address.State.Initials = null;
        }
      } else {
        this.states = [];
        this.partner.Address.State.Initials = null;
      }
      if (this.isSearchZipCode) this.isSearchZipCode = false;
    },
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  mounted() {
    if (this.$route.query.listPending == "true") {
      this.listPending = true;
      this.filter.CodePartnerStatus = 1;
    } else if (this.$route.query.listPendingAcceptedContract == "true") {
      this.listPendingAcceptedContract = true;
      this.filter.IsAcceptedContract = 0;
    } else if (this.$route.query.listModifiedIdentity == "true") {
      this.listModifiedIdentity = true;
      this.filter.IsModifiedIdentity = 1;
    }
    this.ListCountry();
    this.ListPartner();
    this.ListPartnerType();
    this.ListStateFilter();
    this.ListPartnerStatus();

    if (this.$route.query !== undefined && this.$route.query.open == true)
      this.$bvModal.show("mFormPartner");
  },
  methods: {
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    OpenModalFilter: function () {
      this.$bvModal.show("mFilter");
    },
    Filter: function () {
      this.$bvModal.hide("mFilter");
      this.ListPartner();
    },
    HideModal: function () {
      this.$bvModal.hide("mFormPartner");
    },
    GetIsExcludedClass: function (IsExcluded) {
      return IsExcluded
        ? "far fa-times-circle fa-danger"
        : "far fa-check-circle fa-active";
    },
    GoToStep: function (e, stepToGo) {
      e.preventDefault();
      if (stepToGo < this.mSteps.length && stepToGo >= 0) {
        if (stepToGo < this.pCurrentStep) {
          this.pCurrentStep = stepToGo;
        } else {
          this.ProcessNextStep(stepToGo);
        }
      }
    },
    htmlToVNode: function (html) {
      return [
        this.$createElement("div", {
          domProps: { innerHTML: this.$options.filters.breakline(html) },
        }),
      ];
    },
    NextStep: function () {
      if (this.pCurrentStep == 1 && !this.isSeeing) this.pCurrentStep += 4;
      else if (this.pCurrentStep == 4 && !this.HasPartnerTickets)
        this.pCurrentStep += 2;
      else if (this.pCurrentStep < this.mSteps.length - 1)
        this.pCurrentStep += 1;
    },
    ProcessNextStep: function (nextStep = null) {
      if (this.isSeeing) {
        if (nextStep != null) this.pCurrentStep = nextStep;
        else this.NextStep();
        return;
      }
      switch (this.pCurrentStep) {
        case 0:
          this.validatedPartnerStep = true;
          this.CheckValidityStep("PartnerStep", nextStep);
          break;
        case 1:
          this.validatedAddressStep = true;
          this.CheckValidityStep("AddressStep", nextStep);
          break;
        default:
          if (nextStep != null) {
            this.pCurrentStep = nextStep;
          } else {
            this.NextStep();
          }
          break;
      }
    },
    CheckValidityStep(step, nextStep) {
      if (step) {
        this.$refs[step].validate().then((isValid) => {
          if (isValid && nextStep == null) {
            this.NextStep();
          } else if (isValid) {
            if (step == "PartnerStep") {
              this.pCurrentStep = 1;
              this.validatedAddressStep = true;
              this.CheckValidityStep("AddressStep", nextStep);
            } else {
              this.pCurrentStep = nextStep;
            }
          }
        });
      }
    },
    BackStep: function () {
      if (this.pCurrentStep == 5 && !this.isSeeing) this.pCurrentStep -= 4;
      else if (this.pCurrentStep >= 1) this.pCurrentStep -= 1;
    },
    ListMerchantType: function () {
      this.$store
        .dispatch("ListMerchantType")
        .then((response) => {
          this.merchantTypes = response;
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao obter lista de MerchantType",
            error
          );
        });
    },
    ListPartner: function () {
      this.countFilter = 0;
      if (hasValue(this.filter.Id)) this.countFilter++;
      if (hasValue(this.filter.Name)) this.countFilter++;
      if (hasValue(this.filter.Identity)) this.countFilter++;
      if (hasValue(this.filter.CodeMerchantType)) this.countFilter++;
      if (hasValue(this.filter.CodePartnerType)) this.countFilter++;
      if (hasValue(this.filter.CodePartnerStatus)) this.countFilter++;
      if (hasValue(this.filter.IsExcluded)) this.countFilter++;
      if (hasValue(this.filter.IsTest)) this.countFilter++;
      if (hasValue(this.filter.IsAcceptedContract) && this.filter.IsAcceptedContract != 2) this.countFilter++;
      if (hasValue(this.filter.IsModifiedIdentity) && this.filter.IsModifiedIdentity != 2) this.countFilter++;
      if (hasValue(this.filter.AddressFilter.StateFilter.Initials)) this.countFilter++;

      this.loadingList = true;
      let data = this.GetParamsData();
      this.$store
        .dispatch("ListPartner", { params: data })
        .then((response) => {
          this.partners = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao listar os parceiros",
            error
          );
        })
        .finally(() => {
          this.loadingList = false;
        });
    },
    GetGenericName: function (ArrayName, ObjCode) {
      if (!hasValue(ObjCode)) return "";
      let elm = this[ArrayName].find((e) => {
        return e.Code === ObjCode;
      });
      if (elm === undefined) return "";
      return elm.Name || "";
    },
    GetParamsData: function (deletePagination = false) {
      let data = {
        ...this.pagination,
        ...{
          ReportDate: this.reportDate,
          "Object.Id": this.filter.Id,
          "Object.Name": this.filter.Name,
          "Object.Identity": this.filter.Identity,
          "Object.MerchantType.Code": this.filter.CodeMerchantType,
          "Object.PartnerType.Code": this.filter.CodePartnerType,
          "Object.PartnerStatus.Code": this.filter.CodePartnerStatus,
          "Object.IsExcluded": this.filter.IsExcluded,
          "Object.IsTest": this.filter.IsTest,
          "Object.IsAcceptedContractFilter": this.filter.IsAcceptedContract,
          "Object.IsModifiedIdentityFilter": this.filter.IsModifiedIdentity,
          "Object.Address.State.Initials": this.filter.AddressFilter.StateFilter
            .Initials,
        },
      };
      delete data.TotalItems;
      if (deletePagination) {
        delete data.RowsPerPage;
        delete data.PageNumber;
      }
      return data;
    },
    ResetFilter: function () {
      this.filter = {
        Id: undefined,
        Name: null,
        Identity: null,
        CodeMerchantType: null,
        CodePartnerType: null,
        CodePartnerStatus: this.listPending ? 1 : null,
        IsExcluded: false,
        IsTest: false,
        IsAcceptedContract: this.listPendingAcceptedContract ? 0 : 2,
        IsModifiedIdentity: this.listModifiedIdentity ? 1 : 2,
        AddressFilter: {
          StateFilter: {
            Initials: null,
          },
        },
      };
      this.ListPartner();
    },
    ResetActivePartnerResponsible: function () {
      this.activePartnerResponsible = {
        ResponsibleName: null,
        ResponsibleIdentity: null,
        ResponsibleEmail: null,
      };
    },
    GetReport: function (ev) {
      ev.preventDefault();
      this.loadingReport = true;
      let data = this.GetParamsData(true);
      this.$store
        .dispatch("ReportPartner", { params: data })
        .then((response) => {
          if (
            response.UrlReport != null &&
            response.UrlReport != undefined &&
            response.UrlReport != ""
          ) {
            this.$makeToast(
              "Aguarde a conclusão do download",
              "info",
              "Relatório gerado com sucesso"
            );
            window.open(response.UrlReport, "_self");
          }
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao gerar o relatório",
            error
          );
        })
        .finally(() => {
          $("#dropTableOptions").dropdown("hide");
          setTimeout(() => {
            this.loadingReport = false;
          }, 1200);
        });
    },
    OpenModalReportProfit: function (e) {
      e.preventDefault();
      this.$bvModal.show("mReportProfit");
    },
    GetReportProfit: function () {
      this.$makeToast(
        "O relatório está sendo processado e você receberá um e-mail assim que finalizado",
        "info",
        "Relatório de faturamento"
      );
      this.loadingReportProfit = true;
      let data = this.GetParamsData(true);
      this.$store
        .dispatch("ProfitReportPartner", { params: data })
        .then((response) => {
          this.$bvModal.hide("mReportProfit");
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao gerar o relatório",
            error
          );
        })
        .finally(() => {
          $("#dropTableOptions").dropdown("hide");
          setTimeout(() => {
            this.loadingReportProfit = false;
          }, 1200);
        });
    },
    OpenModalReportPerfomance: function (e) {
      e.preventDefault();
      this.$bvModal.show("mReportPerformance");
    },
    GetReportPerformance: function () {
      this.loadingReportPerformance = true;
      let data = this.GetParamsData(true);
      this.$store
        .dispatch("PerformanceReportPartner", { params: data })
        .then((response) => {
          this.$bvModal.hide("mReportPerformance");
          if (
            response.UrlReport != null &&
            response.UrlReport != undefined &&
            response.UrlReport != ""
          ) {
            this.$makeToast(
              "Aguarde a conclusão do download",
              "info",
              "Relatório gerado com sucesso"
            );
            window.open(response.UrlReport, "_self");
          }
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao gerar o relatório",
            error
          );
        })
        .finally(() => {
          $("#dropTableOptions").dropdown("hide");
          setTimeout(() => {
            this.loadingReportPerformance = false;
          }, 1200);
        });
    },

    ListCountry: function () {
      this.$store
        .dispatch("ListCountry")
        .then((response) => {
          this.countries = response;
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro carregar a lista de países",
            error
          );
        });
    },
    ListState: function (nameCountry) {
      if (nameCountry != null) {
        let CountryItem = this.countries.find((elem) => {
          return elem.Name.toUpperCase() == nameCountry;
        });

        if (CountryItem.Id != undefined) {
          this.$store
            .dispatch("ListState", { idCountry: CountryItem.Id })
            .then((response) => {
              this.states = response;
            });
        }
      }
    },
    ListPartnerType: function () {
      this.$store.dispatch("ListPartnerType").then((response) => {
        this.partnerTypes = response;
      });
    },
    ListPartnerStatus: function () {
      this.$store.dispatch("ListPartnerStatus").then((response) => {
        this.partnerStatus = response;
      });
    },
    OpenMPartner: function (e, i, view) {
      e.preventDefault();

      this.ResetPartnerInfo();
      this.pCurrentStep = 0;
      this.pOpened = i;
      this.isSeeing = false;
      this.idPartner = 0;

      if (view == undefined && i != undefined) {
        // Edit
        this.idPartner = this.partners[i].Id;

        // Get partner object with all info.
        this.GetPartner(this.idPartner);

        this.modalTitle = "Editar parceiro";
      } else if (view == undefined && i == undefined) {
        // Add new
        this.pOpened = null;
        this.modalTitle = "Novo parceiro";
        this.partner.PartnerType.Code = 2;
        this.onChangePartnerType(2);
      } else {
        // View
        this.idPartner = this.partners[i].Id;
        this.isSeeing = true;

        this.GetPartner(this.idPartner);
        this.ListPartnerStatusHistory(this.idPartner);
        // this.ListPartnerTickets(this.idPartner);
        this.ListPartnerDocs(this.idPartner);
        this.modalTitle = "Detalhes do parceiro";
      }
      this.$bvModal.show("mFormPartner");
    },
    ResetPartnerInfo: function () {
      this.partnerStatusHistories = [];
      this.partnerTickets = [];

      this.partner = {
        Name: null,
        Identity: null,
        Email: null,
        Phone: null,
        ContactName: null,
        CommercialName: null,
        IsTest: false,
        MerchantType: {
          Code: 1,
        },
        PartnerType: {
          Code: null,
        },
        Address: {
          Street: null,
          District: null,
          Number: null,
          ZipCode: null,
          Complement: null,
          City: {
            Name: null,
          },
          State: {
            Initials: null,
          },
          Country: {
            Name: null,
          },
        },
      };
    },
    CreateOrUpdate: function () {
      if (this.pOpened == null) {
        // Add
        this.AddPartner();
      } else {
        // Update
        this.UpdatePartner();
      }
    },
    SearchByZipCode: function () {
      if (this.isSeeing == false) {
        let zipCodeNumber = this.partner.Address.ZipCode.replace(/\D+/gm, "");

        if (zipCodeNumber.length != 8) {
          this.$makeToast(
            "O CEP digitado não é válido. " + zipCodeNumber,
            "danger",
            "CEP inválido"
          );
          return;
        }

        this.$store
          .dispatch("ListCep", { zipCode: zipCodeNumber })
          .then((response) => {
            if (response.erro) {
              this.$makeToast(
                "Verifique o número digitado e tente novamente.",
                "warning",
                "CEP não encontrado"
              );
              return;
            }
            this.isSearchZipCode = true;

            this.partner.Address.ZipCode = response.cep;
            this.partner.Address.Street = response.logradouro;
            this.partner.Address.District = response.bairro;

            this.partner.Address.Country.Name = "BRASIL";
            this.partner.Address.State.Initials = response.uf;
            this.partner.Address.City.Name = response.localidade;
          })
          .catch((error) => {
            this.$makeToast(
              "Não foi possível buscar o endereço.",
              "danger",
              "Busca de endereço"
            );
          });
      }
    },
    AddPartner: function () {
      this.loadingModal = true;
      this.$store
        .dispatch("AddPartner", { partner: this.partner })
        .then(() => {
          this.$makeToast(
            "Parceiro cadastrado com sucesso",
            "success",
            "Cadastrado"
          );
          this.ListPartner();
          this.$bvModal.hide("mFormPartner");
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao criar o parceiro",
            error
          );
        })
        .finally(() => {
          this.loadingModal = false;
        });
    },
    GetPartner: function (idPartner) {
      this.loadingModal = true;
      this.$store
        .dispatch("GetPartner", { id: idPartner })
        .then((response) => {
          this.partner = response;
          delete this.partner.Address.City.CodeIBGE;
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao carregar o parceiro",
            error
          );
        })
        .finally(() => {
          this.loadingModal = false;
        });
    },
    UpdatePartner: function () {
      this.loadingModal = true;
      if (this.$getUserInternal())
        this.partner.UserInternal = this.$getUserInternal();
      this.$store
        .dispatch("UpdatePartner", { partner: this.partner })
        .then(() => {
          this.$makeToast(
            "O parceiro foi atualizado com sucesso",
            "success",
            "Atualizado"
          );
          this.ListPartner();
          this.$bvModal.hide("mFormPartner");
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao atualizar o parceiro",
            error
          );
        })
        .finally(() => {
          this.loadingModal = false;
        });
    },
    ProcessUpdateExcludedPartner(i, disable) {
      let partner = this.partners[i];
      let identity = this.$options.filters.identity(partner.Identity);

      this.$makeMsgBox(
        `Você tem certeza que deseja ${disable ? "desativar" : "ativar"} ${
          partner.Name
        } (${identity}) ?`,
        "Confirmar ação",
        this.UpdateExcludedPartner,
        partner,
        disable
      );
    },
    UpdateExcludedPartner: function (partner, disable) {
      let label = disable ? "desativado" : "ativado";
      let partnerExcluded = {
        Id: partner.Id,
        IsExcluded: disable,
      };
      this.$store
        .dispatch("UpdateExcludedPartner", partnerExcluded)
        .then(() => {
          this.ListPartner();
          this.$makeToast(
            `${partner.Name} foi ${label}`,
            "success",
            `Parceiro ${label}`
          );
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            `Falha ao ${disable ? "desativar" : "ativar"} ${partner.Name}.`,
            error
          );
        });
    },
    ListStateFilter: function () {
      this.$store.dispatch("ListState", { idCountry: 24 }).then((response) => {
        this.statesFilter = response;
      });
    },
    ProcessUpdatePartnerStatus(i, status, code) {
      let partner = this.partners[i];
      let identity = this.$options.filters.identity(partner.Identity);

      this.$makeMsgBox(
        `Você tem certeza que deseja ${
          status ? "APROVAR" : "RECUSAR"
        } o cadastro de ${partner.Name} (${identity}) ?`,
        "Confirmar ação",
        this.UpdatePartnerStatus,
        partner,
        status,
        code
      );
    },
    UpdatePartnerStatus: function (partner, status, code) {
      let label = status ? "aprovado" : "recusado";

      let partnerStatus = {
        Id: partner.Id,
        PartnerStatus: {
          Code: code,
        },
      };
      this.$store
        .dispatch("UpdatePartnerStatus", partnerStatus)
        .then(() => {
          this.ListPartner();
          this.$makeToast(
            `${partner.Name} foi ${label}`,
            "success",
            `Parceiro ${label}`
          );
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            `Falha ao ${status ? "aprovar" : "recusar"} ${partner.Name}.`,
            error
          );
        });
    },
    ListPartnerStatusHistory: function (id) {
      this.$store
        .dispatch("ListPartnerStatusHistory", { "Object.IdPartner": id })
        .then((response) => {
          this.partnerStatusHistories = response.Objects;
        });
    },
    // ListPartnerTickets: function (idPartner) {
    //   if (!hasValue(idPartner)) return;
    //   const params = {
    //     "Object.Requester.Partner.Id": idPartner,
    //     "Object.IsTest": this.filter.IsTest,
    //   };
    //   this.$store
    //     .dispatch("ListTicket", { params: params })
    //     .then((response) => {
    //       this.partnerTickets = response.Objects;
    //       this.ticketsTableKey += 1;
    //     })
    //     .catch((error) => {
    //       this.$makeToast(
    //         undefined,
    //         "danger",
    //         "Erro ao listar chamados do parceiro.",
    //         error
    //       );
    //     });
    // },
    OpenProspect: function (e, id) {
      e.preventDefault();
      this.$router.push({
        name: "prospects",
        query: {
          idPartner: id,
        },
      });
    },
    OpenMerchant: function (e, id) {
      e.preventDefault();
      this.$router.push({
        name: "merchants",
        query: {
          idPartner: id,
        },
      });
    },
    OpenPartnerCommissions: function (e, id) {
      e.preventDefault();
      this.$router.push({
        name: "partner-commissions",
        query: {
          idPartner: id,
        },
      });
    },
    OpenTicketRegister: function (e, payload) {
      e.preventDefault();
      this.$root.$emit("OpenMTicketRegister", payload);
    },
    OnCloseTicketModal: function (data) {
      // let hasChanges = data.HasChanges;
      // if (hasChanges) this.ListPartnerTickets(this.idPartner);
    },
    Update: function (key, value) {
      if (key != null) this.partner[key] = value;
    },
    ConfirmResendEmail: function (e) {
      e.preventDefault();
      this.$makeMsgBox(
        `Você tem certeza que deseja enviar um e-mail com instruções de definição de senha para ${this.partner.Name}?`,
        "Confirmar",
        this.ResendEmail
      );
    },
    ResendEmail: function () {
      this.loadingResendEmail = true;
      this.$store
        .dispatch("ResendEmailPartner", this.partner)
        .then((response) => {
          this.$makeToast(
            "E-mail reenviado com sucesso",
            "success",
            "Reenviar e-mail"
          );
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao reenviar o e-mail",
            error
          );
        })
        .finally(() => (this.loadingResendEmail = false));
    },
    OpenPartnerTrainings: function (e, id) {
      e.preventDefault();
      this.$router.push({
        name: "partner-trainings",
        params: { idPartner: id },
      });
    },
    OpenPartnerContract: function (e, id) {
      e.preventDefault();
      this.ResetActivePartnerResponsible();
      this.infoPartnerContract = {
        IdPartner: id,
        Responsibles: [],
      };
      this.$bvModal.show("mFormPartnerContract");
    },
    GetPartnerContract: function () {
      this.loadingContract = true;
      this.$store
        .dispatch("GetPartnerContract", this.infoPartnerContract)
        .then((response) => {
          if (
            response.UrlContract != null &&
            response.UrlContract != undefined &&
            response.UrlContract != ""
          ) {
            this.$bvModal.hide("mFormPartnerContract");
            this.$makeToast(
              "Aguarde a conclusão do download",
              "info",
              "Contrato gerado com sucesso"
            );
            window.open(response.UrlContract, "_self");
            this.ListPartner();
          }
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao gerar o contrato",
            error
          );
        })
        .finally(() => {
          $("#dropTableOptions").dropdown("hide");
          setTimeout(() => {
            this.loadingContract = false;
          }, 1200);
        });
    },
    AddPartnerResponsible: function (e) {
      e.preventDefault();
      this.validatedPartnerContract = true;
      this.$refs.PartnerContractForm.validate().then((isValid) => {
        if (!isValid) {
          return;
        } else {
          this.validatedPartnerContract = false;

          if (
            this.infoPartnerContract.Responsibles != null &&
            this.infoPartnerContract.Responsibles != undefined &&
            this.infoPartnerContract.Responsibles.length > 0
          ) {
            const selectedIdentity = this.activePartnerResponsible
              .ResponsibleIdentity;

            let identity = this.infoPartnerContract.Responsibles.find(
              // Search for duplicates
              function (elm) {
                return elm.ResponsibleIdentity == selectedIdentity;
              }
            );

            if (identity != null) {
              this.$makeToast(
                "Este responsável já foi adicionado",
                "danger",
                "Incluir Responsável"
              );
              return;
            }
          }

          this.infoPartnerContract.Responsibles.push({
            Id: this.infoPartnerContract.Responsibles.length + 1,
            ResponsibleName: this.activePartnerResponsible.ResponsibleName,
            ResponsibleIdentity: this.activePartnerResponsible
              .ResponsibleIdentity,
            ResponsibleEmail: this.activePartnerResponsible.ResponsibleEmail,
          });

          this.ResetActivePartnerResponsible();
        }
      });
    },
    RemovePartnerResponsible: function (index) {
      if (index != -1) {
        this.infoPartnerContract.Responsibles.splice(index, 1);
      }
    },
    ListPartnerDocs: function (id) {
      this.partnerDocs = [];
      this.countFilter = 0;
      this.loadingListPartnerDoc = true;
      let data = {
        ...this.pagination,
        ...{
          "Object.Partner.Id": id,
        },
      };
      delete data.TotalItems;
      this.$store
        .dispatch("ListAllPartnerDoc", { params: data })
        .then(
          (response) => {
            this.partnerDocs = response.Objects;
            this.pagination.TotalItems = response.TotalItems;
          },
          (error) => {
            this.$makeToast(
              "Não foi possível listar os documentos",
              "danger",
              "Documentos",
              error
            );
          }
        )
        .finally(() => {
          this.loadingListPartnerDoc = false;
        });
    },
    GetAllPartnerDoc: function (id, download) {
      this.loadingDownload = true;
      this.$store
        .dispatch("GetAllPartnerDoc", { id: id })
        .then((response) => {
          if (download && hasValue(response.Url)) {
            this.$makeToast(
              "Aguarde a conclusão do download",
              "info",
              "Documento"
            );
            window.open(response.Url, "_self");
          }
        })
        .catch((error) => {
          this.$makeToast(
            "Não foi possível buscar as informações do documento",
            "danger",
            "Documento",
            error
          );
        })
        .finally(() => {
          this.loadingDownload = false;
        });
    },
    ConfirmDeletePartnerDoc: function (e, name, i) {
      e.preventDefault();
      this.$makeMsgBox(
        `Você tem certeza que deseja remover ${name}?`,
        "Confirmar",
        this.DeletePartnerDoc,
        i,
        name
      );
    },
    DeletePartnerDoc: function (i, name) {
      this.$store
        .dispatch("DeletePartnerDoc", { id: i })
        .then(() => {
          this.$makeToast(
            `${name} foi removido da sua lista de arquivos`,
            "success",
            "Arquivo"
          );
          this.ListPartnerDocs(this.idPartner);
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao remover o arquivo",
            error
          );
        });
    },
    OpenChangeEmail: function (e, id) {
      e.preventDefault();
      this.loadingChangeEmail = true;
      this.GetPartner(id);
      this.validatedChangeEmail = false;
      this.infoPartnerUpdateEmail = {
        Id: id,
        Email: null,
        ResponsibleIdentity: null,
      };
      this.$bvModal.show("mChangeEmail");
      this.loadingChangeEmail = false;
    },
    UpdateEmail: function () {
      this.validatedChangeEmail = true;
      this.$refs.ChangeEmailForm.validate().then((isValid) => {
        if (isValid) {
          this.validatedChangeEmail = false;
          this.infoPartnerUpdateEmail.ResponsibleIdentity = this.partner.ResponsibleIdentity;
          this.$store
            .dispatch("UpdatePartnerEmail", this.infoPartnerUpdateEmail)
            .then(() => {
              this.ListPartner();
              this.$makeToast(
                `E-mail atualizado com sucesso.`,
                "success",
                `Parceiro atualizado com sucesso.`
              );
            })
            .catch((error) => {
              this.$makeToast(
                undefined,
                "danger",
                `Falha ao atualizar o E-mail.`,
                error
              );
            })
            .finally(() => {
              this.$bvModal.hide("mChangeEmail");
              this.loadingChangeEmail = false;
              this.validatedChangeEmail = false;
            });
        }
      });
    },
    ValidateUpdateEmail: function () {
      this.validatedChangeEmail = true;
      this.$refs.ChangeEmailForm.validate().then((isValid) => {
        if (isValid) {
          this.validatedChangeEmail = false;
          this.infoPartnerUpdateEmail.ResponsibleName = this.partner.ResponsibleName;
          this.infoPartnerUpdateEmail.Name = this.partner.Name;
          this.infoPartnerUpdateEmail.ResponsibleIdentity = this.partner.ResponsibleIdentity;
          this.infoPartnerUpdateEmail.Identity = this.partner.Identity;
          this.infoPartnerUpdateEmail.IsTest = this.partner.IsTest;
          this.$store
            .dispatch("ValidatePartnerUpdateEmail", this.infoPartnerUpdateEmail)
            .then((response) => {
              if (response.MessageWarning) {
                this.ConfirmHasErrorValidateEmail(response);
              } else {
                this.UpdateEmail();
              }
            })
            .catch((error) => {
              this.$makeToast(
                undefined,
                "danger",
                "Erro ao validar o parceiro",
                error
              );
            })
            .finally(() => {
              this.loadingChangeEmail = false;
            });
        }
      });
    },
    ConfirmHasErrorValidateEmail: function (response) {
      this.$makeMsgBox(
        this.htmlToVNode(
          response.MessageWarning + " Você tem certeza que deseja continuar?"
        ),
        "Confirmar",
        this.UpdateEmail,
        response
      );
    },

    onChangePartnerType: function (value) {
      if(value == 2) {
        this.partner.MerchantType.Code = '2';
        this.isDisableMerchantType = true;
      } else {
        this.partner.MerchantType.Code = '1';
        this.isDisableMerchantType = true;
      }
    },
    AbrirParceiroAtendimentoIdParceiro: function (e, id) {
      e.preventDefault();
      this.$router.push({
        name: "ParceiroAtendimentoIdParceiro",
        params: { idPartner: id },
      });
    },
  },
};
</script>
<style scoped>
.td-with-subs {
  display: block;
}
.td-with-subs > span {
  font-size: 10pt;
  opacity: 0.75;
}
.nav-steps .breadcrumb-item:before {
  content: none;
}
.nav-steps .breadcrumb-item .active {
  text-decoration: underline;
  font-weight: 600;
}
.fa-danger {
  color: #ff0000;
}
.fa-active {
  color: green;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/partners.vue